import { forwardRef, type HTMLAttributes } from "react";
import { cn } from "../lib/cn";

type Padding = "none" | "sm" | "md" | "lg";
type Radius = "md" | "lg" | "xl" | "2xl";

type GlassCardProps = HTMLAttributes<HTMLDivElement> & {
  padding?: Padding;
  radius?: Radius;
};

const paddingMap: Record<Padding, string> = {
  none: "p-0",
  sm: "p-3",
  md: "p-5",
  lg: "p-7",
};
const radiusMap: Record<Radius, string> = {
  md: "rounded-md",
  lg: "rounded-lg",
  xl: "rounded-xl",
  "2xl": "rounded-2xl",
};

export const GlassCard = forwardRef<HTMLDivElement, GlassCardProps>(
  ({ className, padding = "md", radius = "2xl", children, ...rest }, ref) => (
    <div
      ref={ref}
      className={cn(
        "kj-glass kj-noise relative overflow-hidden",
        paddingMap[padding],
        radiusMap[radius],
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  ),
);
GlassCard.displayName = "GlassCard";
